/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_SeniorityInputs */

const en_jobs_seniority = /** @type {(inputs: Jobs_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seniority`)
};

const de_jobs_seniority = /** @type {(inputs: Jobs_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfahrungsstufe`)
};

const fr_jobs_seniority = /** @type {(inputs: Jobs_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau d'expérience`)
};

const es_jobs_seniority = /** @type {(inputs: Jobs_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivel de experiencia`)
};

const it_jobs_seniority = /** @type {(inputs: Jobs_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esperienza`)
};

const nl_jobs_seniority = /** @type {(inputs: Jobs_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senioriteit`)
};

const pl_jobs_seniority = /** @type {(inputs: Jobs_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poziom doświadczenia`)
};

const fi_jobs_seniority = /** @type {(inputs: Jobs_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kokemus­taso`)
};

const da_jobs_seniority = /** @type {(inputs: Jobs_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senioritet`)
};

const sv_jobs_seniority = /** @type {(inputs: Jobs_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senioritet`)
};

/**
* | output |
* | --- |
* | "Seniority" |
*
* @param {Jobs_SeniorityInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_seniority = /** @type {((inputs?: Jobs_SeniorityInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_SeniorityInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_seniority(inputs)
	if (locale === "fr") return fr_jobs_seniority(inputs)
	if (locale === "es") return es_jobs_seniority(inputs)
	if (locale === "it") return it_jobs_seniority(inputs)
	if (locale === "nl") return nl_jobs_seniority(inputs)
	if (locale === "pl") return pl_jobs_seniority(inputs)
	if (locale === "fi") return fi_jobs_seniority(inputs)
	if (locale === "da") return da_jobs_seniority(inputs)
	if (locale === "sv") return sv_jobs_seniority(inputs)
	return en_jobs_seniority(inputs)
});